export const country = {
  data: [
    {
      name: 'Indonesia',
      code: 'ID',
      description:
        "Indonesia is not only Southeast Asia's largest economy but also its largest and most competitive e-commerce market, with an estimated e-commerce GMV of nearly __bn USD in 2023.",
      id: '1',
      type: 'countries',
    },
    {
      name: 'Malaysia',
      code: 'MY',
      description:
        'Malaysia is a mid-sized e-commerce market, smaller than regional peers Indonesia and Thailand but with higher per-capita online spending, and an estimated e-commerce GMV of nearly __bn USD in 2023.',
      id: '2',
      type: 'countries',
    },
    {
      name: 'Philippines',
      code: 'PH',
      description:
        'The Philippines is a mid-sized e-commerce market with an estimated e-commerce GMV of nearly __bn USD in 2023, but with significant growth potential as incomes and spending rise over the next decade.',
      id: '3',
      type: 'countries',
    },
    {
      name: 'Vietnam',
      code: 'VN',
      description:
        "Vietnam is Southeast Asia's 3rd largest e-commerce market, with an estimated e-commerce GMV of nearly __bn USD in 2023, with active competition from regional as well as home-grown platforms.",
      id: '4',
      type: 'countries',
    },
    {
      name: 'Singapore',
      code: 'SG',
      description:
        "Singapore is Southeast Asia's smallest e-commerce market, with an estimated e-commerce GMV of nearly __bn USD in 2023, but has the highest per-capita online spending.",
      id: '5',
      type: 'countries',
    },
    {
      name: 'Thailand',
      code: 'TH',
      description:
        "Thailand is Southeast Asia's 2nd largest e-commerce market (after Indonesia), with an estimated e-commerce GMV of nearly __bn USD in 2023, growing at __% per year.",
      id: '6',
      type: 'countries',
    },
    {
      name: 'China',
      code: 'CN',
      description: '',
      id: '7',
      type: 'countries',
    },
    {
      name: 'Taiwan',
      code: 'TW',
      description: '',
      id: '8',
      type: 'countries',
    },
    {
      name: 'Brazil',
      code: 'BR',
      description: '',
      id: '9',
      type: 'countries',
    },
  ],
};

export const markets = {
  data: [
    {
      name: 'Indonesia',
      code: 'ID',
      description:
        "Indonesia is not only Southeast Asia's largest economy but also its largest and most competitive e-commerce market, with an estimated e-commerce GMV of nearly __bn USD in 2023.",
      id: '1',
      type: 'countries',
    },
    {
      name: 'Malaysia',
      code: 'MY',
      description:
        'Malaysia is a mid-sized e-commerce market, smaller than regional peers Indonesia and Thailand but with higher per-capita online spending, and an estimated e-commerce GMV of nearly __bn USD in 2023.',
      id: '2',
      type: 'countries',
    },
    {
      name: 'Philippines',
      code: 'PH',
      description:
        'The Philippines is a mid-sized e-commerce market with an estimated e-commerce GMV of nearly __bn USD in 2023, but with significant growth potential as incomes and spending rise over the next decade.',
      id: '3',
      type: 'countries',
    },
    {
      name: 'Vietnam',
      code: 'VN',
      description:
        "Vietnam is Southeast Asia's 3rd largest e-commerce market, with an estimated e-commerce GMV of nearly __bn USD in 2023, with active competition from regional as well as home-grown platforms.",
      id: '4',
      type: 'countries',
    },
    {
      name: 'Singapore',
      code: 'SG',
      description:
        "Singapore is Southeast Asia's smallest e-commerce market, with an estimated e-commerce GMV of nearly __bn USD in 2023, but has the highest per-capita online spending.",
      id: '5',
      type: 'countries',
    },
    {
      name: 'Thailand',
      code: 'TH',
      description:
        "Thailand is Southeast Asia's 2nd largest e-commerce market (after Indonesia), with an estimated e-commerce GMV of nearly __bn USD in 2023, growing at __% per year.",
      id: '6',
      type: 'countries',
    },
    {
      name: 'China',
      code: 'CN',
      description: '',
      id: '7',
      type: 'countries',
    },
    {
      name: 'Taiwan',
      code: 'TW',
      description: '',
      id: '8',
      type: 'countries',
    },
  ],
};

export const countryAbbreviations: Record<string, string> = {
  Singapore: 'SG',
  Malaysia: 'MY',
  Indonesia: 'ID',
  Thailand: 'TH',
  Vietnam: 'VN',
  Philippines: 'PH',
  Taiwan: 'TW',
  China: 'CN',
  Brazil: 'BZ',
};
